/**
 * DemoAccessGuard — CaraLoom Controlled Demo Environment (iter 179).
 *
 * Two-tier access to /demo/preview:
 *   1. Any authenticated CaraLoom user (uses the existing ProtectedRoute-style
 *      check under the hood). These are presenters / internal reviewers.
 *   2. A prospect who just booked a demo and had `grantDemoAccess()` called
 *      after successful inquiry submission — stored in sessionStorage.
 *
 * Unauthenticated visitors without a granted demo-token are sent to `/auth`.
 * The URL alone is NOT the security mechanism.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { hasDemoAccess, DemoProvider } from '../../contexts/DemoContext';

export default function DemoAccessGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-cn-bg flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-cn-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!hasDemoAccess({ user })) {
    // Unauthorised → send to sign-in with a `next` back to the demo entry.
    return <Navigate to="/auth?next=/demo/preview" replace />;
  }
  return <DemoProvider>{children}</DemoProvider>;
}
